/**
 * CustomerSettingsPage — a customer's Settings tab, `/customers/:customerId/settings`
 * (docs/features/journey-visual-language/01_proposal.md §5.8): one page, full
 * width, with no sub-tabs. Credit control owns most of it (docs/features/credit-control/
 * 06_ui_strategy.md, decision 10): the billing account strip and Payment
 * methods, with the sales ledger's invoicing settings (order to invoice doc
 * 50, SL1) nested under credit account and in Stock billing. Orders' "Ordering"
 * section follows (V1 completion O), behind `v1_completion`. Above them all, also
 * behind `v1_completion`, account allocation's "Sales rep and CSR" (v1 completion C5).
 * The catalogue's setting that new items need the customer's product reference is
 * a switch on the customer's One record, not a section here.
 */
import { isFeatureEnabled } from "@shared-core/config/features";
import { useCustomerRouteId } from "../app/components/domain/customers/useCustomerRouteId";
import { CustomerFrame } from "../app/components/domain/customers/CustomerFrame";
import { CustomerSettingsBody } from "../app/components/domain/credit-control/CustomerSettingsBody";
import { CustomerOrderingSettingsSection } from "../app/components/domain/orders/CustomerOrderingSettingsSection";
import { CustomerOwnersSection } from "../app/components/domain/customers/CustomerOwnersSection";

export function CustomerSettingsPage() {
  const customerId = useCustomerRouteId();
  if (customerId === null) return null;
  return (
    <CustomerFrame customerId={customerId} current="settings">
      <div className="space-y-4">
        {isFeatureEnabled("v1_completion") && (
          <CustomerOwnersSection customerKey={customerId} />
        )}
        <CustomerSettingsBody customerId={customerId} />
        {isFeatureEnabled("v1_completion") && (
          <CustomerOrderingSettingsSection customerKey={customerId} />
        )}
      </div>
    </CustomerFrame>
  );
}
